import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  DeleteButton,
  ShowButton,
} from "react-admin";

export const PostList = (props) => (
  <List {...props} show="true">
    <Datagrid bulkActionButtons={false}>
      <TextField source="userName" />
      <TextField source="id" />
      <TextField source="postMessage" />
      <TextField source="likes" />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
